let paused = false;

export function pauseHardwareScans(): void {
  paused = true;
}

export function resumeHardwareScans(): void {
  paused = false;
}

export function isHardwareScanPaused(): boolean {
  return paused;
}
